import { render, staticRenderFns } from "./DockerComposeIcon.vue?vue&type=template&id=249e59d8"
import script from "./DockerComposeIcon.vue?vue&type=script&lang=js"
export * from "./DockerComposeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports